import mixinDependencies from 'shared/angularjs/services/acp-modal-state-provider';
import { acpMeToMeTransfer } from './states';

export default function(appModule) {
  mixinDependencies(appModule);
  appModule.config(acpMeToMeTransfer);
}
